import {message} from "antd";

export const displayError = (msg, error) => {
	console.log("Error: ", error || msg);
	message.error(msg, 5);
}
